/* ─── Root ─── */

.root {
  position: fixed;
  bottom: 0;
  inset-inline: 0;
  z-index: var(--z-sticky);
  background: var(--md-surface-container);
  box-shadow: var(--elevation-2);
  font-family: var(--font-sans);
}

/* ─── List ─── */

.list {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  height: 80px;
}

/* ─── Item ─── */

.item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-1);
  text-decoration: none;
  color: var(--md-on-surface-variant);
  border: none;
  background: transparent;
  cursor: pointer;
  padding: var(--space-2) 0;
  position: relative;
  font-family: var(--font-sans);
}

.item[data-active] {
  color: var(--md-primary);
}

.item:focus-visible {
  border-radius: var(--shape-xs);
}

/* ─── Icon ─── */

.itemIcon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}

/* Active indicator pill behind icon */
.itemIcon::before {
  content: "";
  position: absolute;
  width: 64px;
  height: 32px;
  border-radius: var(--shape-full);
  background: var(--md-primary-container);
  z-index: -1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: transform var(--motion-duration-short3)
      var(--motion-easing-standard),
    opacity var(--motion-duration-short3) var(--motion-easing-standard);
}

.item:not([data-active]) .itemIcon::before {
  opacity: 0;
  transform: translate(-50%, -50%) scaleX(0);
}

/* ─── Label ─── */

.itemLabel {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
}
